<template>
  <div class="composite-aside-content">
    <CommonAsideHeader :title="title" />
    <div class="composite-aside-content-container">
      <p class="subtitle">{{ subtitle }}</p>

      <CommonAsideCard :key-info="keyInfo" :key-info-label="keyInfoLabel" :tip-key="tipKey" :tip-key-label="tipKeyLabel"
        :tip-description="tipDescription" :tip-green-background="tipGreenBackground" :tips="tips">
        <template #key-info-icon>
          <slot name="key-info-icon" />
        </template>
        <template #tip-icon>
          <slot name="tip-icon" />
        </template>
      </CommonAsideCard>
    </div>
  </div>
</template>

<script lang="ts" setup>
import CommonAsideCard from '../common/CommonAsideCard.vue'
import CommonAsideHeader from '../common/CommonAsideHeader.vue'

defineProps<{
  title: string
  subtitle: string
  keyInfo: string
  keyInfoLabel: string
  tipKey?: string
  tipKeyLabel?: string
  tipDescription?: string[]
  tips?: { tipKey: string, tipKeyLabel: string }[]
  tipGreenBackground?: boolean
}>()
</script>

<style lang="scss" scoped>
.composite-aside {
  &-content {
    display: flex;
    flex-direction: column;
    background-color: rgba(#41693d, 0.25);
    height: 100%;
    border-bottom-right-radius: 40px;
    border-bottom-left-radius: 40px;

    &-container {
      padding: var(--spacer);
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    .subtitle {
      text-transform: uppercase;
      text-align: center;
      color: var(--vc-green);
      font-size: 26px;
      font-weight: 600;
      line-height: 1.2;
      margin: var(--spacer) 0;
    }
  }
}
</style>
